module.exports = __webpack_public_path__ + "img/compare.361c5e4b.svg";